import React from 'react'

import SelectComponent from '../../../src/components/UI/forms/Select.js'
import Popup from '../../../src/components/UI/overlays/Popup.js'

class Select extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            focused: false
        }
    }

    async focus() {
        this.blur()

        const options = this.props.options.map((option) => {
            option.selected = this.props.values ? this.props.values.includes(option.value) : option.value === this.props.value && (option.subvalue || '') === (this.props.subvalue || '')

            return option
        })

        if (this.props.values) {
            const values = await this.popup.openOptions(this.props.label, '', options, undefined, true)
            if (!values) return

            this.props.onChange({target: {values}})
        } else {
            const option = await this.popup.openOptions(this.props.label, '', options)
            if (!option) return

            this.props.onChange({target: {value: option.value, subvalue: option.subvalue || ''}})
        }
    }

    blur() {
        this.input?.blur()
    }

    render() {
        return (
            <>
                <SelectComponent
                    {...this.props}
                    inputStyle={{minWidth: 10}}
                    onFocus={() => this.focus()}
                    onChange={() => {/* Empty onChange handler is needed for the input component to work properly */}}
                    ref={(ref) => this.input = ref}
                />

                <Popup
                    closeButton={true}
                    closeOnEscape={false}
                    showOptionRadioButton
                    ref={(ref) => this.popup = ref}
                />
            </>
        )
    }
}

export default Select
